import Component from './component';

export { BannerLeft, BannerRight } from './component';

export default Component;
